// UserInfoModal.js
import React, { useState } from 'react';

function UserInfoModal({ onSave, userInfo, setUserInfo }) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const [isEmailValid, setIsEmailValid] = useState(true);

    const handleEmailChange = (e) => {
        const emailInput = e.target.value;
        setUserInfo(prevState => ({ ...prevState, email: emailInput }));

        if (emailInput) {
            setIsEmailValid(emailRegex.test(emailInput));
        } else {
            setIsEmailValid(true);
        }
    };

    const formatPhoneNumber = (inputValue, keyPress) => {
        let txt = inputValue;
        if (keyPress === 'Backspace' && txt.endsWith('-')) {
            txt = txt.slice(0, -1);
        }
        txt = txt.replace(/\+1/, '').replace(/\D/g, '');
        const n = txt.length;
        switch (true) 
        {
            case (n <= 3):
                break;
            case (n > 3 && n <= 6):
                txt = txt.substring(0, 3) + '-' + txt.substring(3, 6);
                break;
            case (n > 6):
                txt = txt.substring(0, 3) + '-' + txt.substring(3, 6) + '-' + txt.substring(6);
                break;
            default:
                break;
        }
        return '+1 ' + txt;
    };

    const handlePhoneNumberChange = (e) => {
        const formattedNumber = formatPhoneNumber(e.target.value, e.nativeEvent.inputType);
        setUserInfo(prevState => ({ ...prevState, phoneNumber: formattedNumber }));
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setUserInfo(prevState => ({ ...prevState, [name]: value }));
    };
    
    return (
        <div className="modal">
            <div className="modal-content">
                <img src="/Logo-5.png" alt="Omntec Logo" className="modal-logo" />
                <h2 style={{color: 'white'}}>Facility Information</h2>
                <input
                    type="email"
                    name="email"
                    placeholder="Email" 
                    value={userInfo.email} 
                    onChange={handleEmailChange} 
                />
                {!isEmailValid && <span style={{ color: 'red' }}>Invalid email format</span>}
                <input 
                    type="text" 
                    name="name" 
                    placeholder="Name" 
                    value={userInfo.name} 
                    onChange={handleInputChange} 
                />
                <input 
                    type="text" 
                    name="company" 
                    placeholder="Company" 
                    value={userInfo.company} 
                    onChange={handleInputChange} 
                />
                <div className="input-group">
                    <input
                        type="text"
                        name="projectName"
                        placeholder="Project Name"
                        value={userInfo.projectName}
                        onChange={(e) => setUserInfo({ ...userInfo, projectName: e.target.value })}
                    />
                </div>
                <input 
                    type="text" 
                    name="city" 
                    placeholder="City" 
                    value={userInfo.city} 
                    onChange={handleInputChange} 
                />
                <input 
                    type="text" 
                    name="state" 
                    placeholder="State" 
                    value={userInfo.state} 
                    onChange={handleInputChange} 
                />
                <input 
                    type="tel" 
                    name="phoneNumber" 
                    placeholder="888 888 8888" 
                    maxLength="15" 
                    value={userInfo.phoneNumber} 
                    onChange={handlePhoneNumberChange} 
                />
                
                <button onClick={onSave}>Start</button>
            </div>
        </div>
    );
}

export default UserInfoModal;
